import React from 'react';
import { Flex } from '@chakra-ui/react'
import DocumentItem from './DocumentItem';
import files from '../../assets/json/files.json'

export default function DocumentWrap() {
    return (
        <Flex 
            alignItems={'center'} 
            wrap='wrap' 
            px='6' 
            py={'8'} 
            marginTop='6' 
            marginBottom='6'
            marginLeft={'auto'}
            marginRight={'auto'}
            paddingLeft='50px'
        >
            {files.map(file => (
                <DocumentItem key={file.id} {...file} />
            ))}
        </Flex>
    )
}